import { OPERATES } from 'enum/Operate';

export type LimitationOp = OPERATES | 'other';
export type LimitationData = {
  [T in LimitationOp]: Limitation[];
};

export type Limitation = {
  op?: string;
  value: Array<SelectOptions & { isGroup?: boolean }> | string | number;
  type: string;
  isGroup?: boolean;
};

export type SavedTargeting = {
  id: number | string;
  advertiserId: number;
  channel: string;
  name: string;
  targeting: any[];
  accessMinVersion: number;
  version: number;
};

export type ServerLimitation = {
  op: string;
  limits: (SelectOptions & { isGroup?: boolean })[] | string | number;
  type: string;
  isGroup?: boolean;
};

export enum WeatherType {
  WEATHER_CODE = 'weatherCode',
  TEMPERATURE = 'temperature',
  PROBABILITY_OF_PRECIPITATION = 'probabilityOfPrecipitation',
  UV_INDEX = 'uvIndex',
  RELATIVE_HUMIDITY = 'relativeHumidity'
}

export type EstimatedAudience = {
  estimateReady: boolean;
  upperBound: number;
  lowerBound: number;
  warning?: string;
};
